import { Box, Checkbox, IconButton, Input } from '@material-ui/core';
import React from 'react';

const CheckboxCell = React.memo(
  ({ row, column, rowState, handleRowChange }) => {
    React.useEffect(() => {
      if ((row[column.key] || {}).hasOwnProperty('value')) {
        handleRowChange(row.id, {
          [column.key]:
            rowState[column.key] !== undefined
              ? rowState[column.key]
              : !!(row[column.key] || {}).value,
        });
      }
    }, [row]);

    return (
      <Box
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
        }}
      >
        <Checkbox
          disabled={(row[column.key] || {}).cellEditable === false}
          checked={
            rowState[column.key] !== undefined
              ? !!rowState[column.key]
              : !!(row[column.key] || {}).value
          }
          onClick={(event) =>
            handleRowChange(row.id, { [column.key]: !rowState[column.key] })
          }
        />
      </Box>
    );
  },
  (prevProps, currentProps) =>
    (prevProps.rowState || {})[(prevProps.column || {}).key] ===
      (currentProps.rowState || {})[(currentProps.column || {}).key] &&
    prevProps.delected === currentProps.selected
);

export default CheckboxCell;
